"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisitDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Venue_dto_1 = require("./Venue.dto");
const User_dto_1 = require("./users/User.dto");
const enums_1 = require("../../enums");
class VisitDto {}
exports.VisitDto = VisitDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VisitDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], VisitDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => User_dto_1.UserDto
}), __metadata("design:type", User_dto_1.UserDto)], VisitDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VisitDto.prototype, "checkedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VisitDto.prototype, "checkedOutAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VisitDto.prototype, "secondsInVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VisitDto.prototype, "checkoutType", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VisitDto.prototype, "messagesReceived", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VisitDto.prototype, "messagesSent", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VisitDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VisitDto.prototype, "pings", void 0);
//# sourceMappingURL=Visit.dto.js.map